<template>
  <div class="boxmeme">
    <el-alert title="基本信息" type="success" :closable="false" style="border-radius:0;"></el-alert>
    <el-descriptions class="margin-top" title="" :column="3" size="medium" border :label-style="{'width':'160px'}" :content-style="{'width':'227px'}">
      <el-descriptions-item label="头像">
        <el-avatar :size="25" :src="info.avatar" @error="true">
          <img :src="base_url+'uploads/default_avatar.png'">
        </el-avatar>
      </el-descriptions-item>
      <el-descriptions-item label="昵称">{{ info.nickname || '--' }}</el-descriptions-item>
      <el-descriptions-item label="手机号">{{ info.phone || '--' }}</el-descriptions-item>
      <el-descriptions-item label="性别">{{ info.gender | genderFilter }}</el-descriptions-item>
      <el-descriptions-item label="年龄">{{ info.age || '--' }}</el-descriptions-item>
      <el-descriptions-item label="状态">{{ info.status | statusFilter }}</el-descriptions-item>
      <el-descriptions-item label="余额">￥{{ info.money }}</el-descriptions-item>
      <el-descriptions-item label="是否会员">{{ info.is_member | yesno }}</el-descriptions-item>
      <el-descriptions-item label="会员级别">{{ info.member_level || '--' }}</el-descriptions-item>
      <el-descriptions-item label="会员开始时间">{{ info.member_start || '--' }}</el-descriptions-item>
      <el-descriptions-item label="会员结束时间">{{ info.member_end || '--' }}</el-descriptions-item>
      <el-descriptions-item label="是否教练">{{ info.is_coach | yesno }}</el-descriptions-item>
    </el-descriptions>
    <el-alert title="个人卡片" type="success" :closable="false" style="margin-top:20px;border-radius:0;"></el-alert>
    <el-descriptions class="margin-top" title="" size="medium" border :label-style="{'width':'160px'}" :content-style="{'width':'227px'}">
      <el-descriptions-item label="是否可被邀约">{{ info.is_invite | yesno }}</el-descriptions-item>
      <el-descriptions-item label="发球成功率">{{ info.serve_success_rate || '--' }}</el-descriptions-item>
      <el-descriptions-item label="发球ace次数">{{ info.serve_ace_num || '--' }}</el-descriptions-item>
      <el-descriptions-item label="发球速度">{{ info.serve_speed || '--' }}</el-descriptions-item>
      <el-descriptions-item label="接发球成功率">{{ info.serve_receive_success_rate || '--' }}</el-descriptions-item>
      <el-descriptions-item label="接发球破发率">{{ info.serve_break_success_rate || '--' }}</el-descriptions-item>
      <el-descriptions-item label="击球成功率">{{ info.hit_success_rate || '--' }}</el-descriptions-item>
      <el-descriptions-item label="正手击球率">{{ info.forehand_rate || '--' }}</el-descriptions-item>
      <el-descriptions-item label="反手击球率">{{ info.backhand_rate || '--' }}</el-descriptions-item>
      <el-descriptions-item label="底线得分率">{{ info.bottom_score_rate || '--' }}</el-descriptions-item>
      <el-descriptions-item label="平均击球速度">{{ info.average_hit_speed || '--' }}</el-descriptions-item>
      <el-descriptions-item label="最高击球速度">{{ info.max_hit_speed || '--' }}</el-descriptions-item>
      <el-descriptions-item label="图片" :span="3">
        <el-image v-for="(image,index) in info.card_images" :key="index" style="width: 100px; height: 100px;margin-bottom:5px;margin-right:5px;" :preview-src-list="info.card_images" :src="image" fit="fill"></el-image>
      </el-descriptions-item>
      <el-descriptions-item label="视频" :span="3">
        <video v-for="(video,index) in info.card_video" :key="index" :src="video" width="150" height="100" style="margin-bottom:5px;margin-right:5px;" controls="controls"></video>
      </el-descriptions-item>
    </el-descriptions>
    <el-alert title="会员套餐详情" type="success" :closable="false" style="margin-top:20px;border-radius:0;"></el-alert>
    <el-alert title="课程套餐详情" type="success" :closable="false" style="margin-top:20px;border-radius:0;"></el-alert>

  </div>
</template>

<script>
import api from '@/api/user' // 和数据交互相关写在api 方便复用
export default {
  name: 'User',
  // 列绑定格式化器
  filters: {
    genderFilter(val) {
      switch (val) {
        case 1:
          return '男'
        case 2:
          return '女'
        default:
          return '未知'
      }
    },
    statusFilter(val) {
      switch (val) {
        case 1:
          return '启用'
        default:
          return '禁用'
      }
    },
    yesno(val) {
      switch (val) {
        case 1:
          return '是'
        default:
          return '否'
      }
    }
  },
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      base_url: process.env.VUE_APP_BASE_API,
      api,
      info: {}
    }
  },
  watch: {
    id() {
      this.loadData()
    }
  },
  created() {
    this.loadData() // 页面加载创建时加载数据
  },
  methods: {
    loadData() {
      this.api.Detail({ id: this.id }).then(response => {
        if (response.data.card_images) {
          response.data.card_images = response.data.card_images.split(',')
        } else {
          response.data.card_images = []
        }
        if (response.data.card_video) {
          response.data.card_video = response.data.card_video.split(',')
        } else {
          response.data.card_video = []
        }
        this.info = response.data
      })
    }
  }
}
</script>

<style scoped>
::-webkit-scrollbar {
    width: 5px;  /* 定义滚动条的宽度 */
}
::-webkit-scrollbar-track {
    background: #ecf5ff; /* 定义轨道的背景颜色 */
}
::-webkit-scrollbar-thumb {
    background: #b3d8ff; /* 定义滑块的背景颜色 */
}
::-webkit-scrollbar-thumb:hover {
    background: #b3d8ff; /* 定义滑块在悬停状态下的背景颜色 */
}
.boxmeme{
  height:65vh;
  overflow-y: scroll;
}
.margin-top {
  margin-top: 0px;
}
</style>
